import { useEffect } from 'react';

import { stocklistActions } from '../actions';
import { ListState } from '../reducers/stocklist.reducer';
import useDispatch from './useDispatch';
import useRegion from './useRegion';
import { useUser } from './users';
import useSelector from './useSelector';

export const useUserStockList = (): ListState => {
  const {
    list: { users, loading },
  } = useSelector(state => state.stocklist);

  const dispatch = useDispatch();
  const region = useRegion();

  const user = useUser();

  useEffect(() => {
    if (user && !loading && !users) {
      dispatch(stocklistActions.getUserStockList(region));
    }
  }, [dispatch, loading, region, user, users]);

  return { users, loading };
};
